<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { LazyMarkdown } from '../../../../components/LazyMarkdown';
	import { TxtVariantsMap } from '../../../../components/Txt';
	import { extractNonNull } from '../../../../utils/extractNonNull/extractNonNull';
	import type { ArticleImageType } from '../../types';

	interface Props {
		enableContain: boolean;
		item: NonNullable<ArticleImageType>;
		getImageUrl: (path: string | null | undefined) => void;
		onclick?: ((image: ArticleImageType) => void) | undefined;
	}

	let { enableContain, item, getImageUrl, onclick = undefined }: Props = $props();

	let safeItem = $derived(
		extractNonNull(item, ['image'], {
			image: (data) => getImageUrl(data?.filename_disk)
		})
	);

	let handleClickImage = $derived(() => {
		if (onclick) {
			onclick(item);
		}
	});
</script>

{#if safeItem}
	{#if safeItem.layout === 'cover' || !enableContain}
		{#if onclick}
			<button onclick={handleClickImage} aria-label="View image full size">
				<img src={safeItem.image} alt={safeItem.legend} data-cy="blog-article-image" />
			</button>
		{:else}
			<img src={safeItem.image} alt={safeItem.legend} data-cy="blog-article-image" />
		{/if}
	{:else}
		<div class="bg-gray-75 flex aspect-video w-full items-center justify-center">
			<img
				src={safeItem.image}
				alt={safeItem.legend}
				data-cy="blog-article-image"
				class="max-h-full max-w-full"
			/>
		</div>
	{/if}
	{#if safeItem.legend}
		<LazyMarkdown
			dataCy="blog-article-image-legend"
			class={twMerge(
				TxtVariantsMap.label4,
				'mt-1 [&>p>span]:text-[0.75rem] [&>p>span]:leading-[1rem] [&>p>span]:text-gray-500 [&>p]:text-[0.75rem] [&>p]:leading-[1rem] [&>p]:text-gray-500'
			)}
			source={item.legendTokens ?? safeItem.legend}
		/>
	{/if}
{/if}
